import { Global } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';

import MainBanner from '../../../components/MainBanner';
import SimpleContent from '../../../components/SimpleContent';
import Link from "next/link"

export default function ContactUsPageSubmissionSuccess({
    global,
}) {
    return (
        <>
            <SeoHead
                page_name={`Submission Success | Staffing Agency | US and Canada Staffing | Bartech Staffing`}
                canonical_link={`business-solutions/submission-success`}
            />
            <MainBanner
                global={global}
                pathPrefix={`business_solutions_page_submission_success_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Submission Success</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <SimpleContent
                global={global}
                pathPrefix={`business_solutions_page_submission_success_page.simple_content`}
                customClass={`py-5 text-center`}
                content={
                    <>
                        <p>Your submission has been successfully submitted.</p>
                        <p>We will be in touch shortly!</p>
                    </>}
                editableText={true}
                buttonTitle1={`Back to jobs`}
                buttonTitleLink1={`/jobs/`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    return {
        props: {
            global,
        }
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext